
import * as AllGames from "../index.js"; // this gives you access to BinaryTreeIntroduction, etc.

export const getHashGames = (subcategory, stage) => {
    if (subcategory === "Chaining") {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.IntroChaining />;
            case "functions":
                return <AllGames.FunctionChaining />;
            case "searching":
                return <AllGames.HashTableSearchingChaining />;
            case "insertion-deletion":
                return <AllGames.InsertDeleteChaining />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }

    return <p style={{ color: "black" }}>Δεν υποστηρίζεται αυτό το δέντρο.</p>;
};
